/**
 * @description: 账单汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="zh-report">
        <div class="zh-list">
            <p class="p-hint">注：1、统计的数据已扣除退款金额和退货数量</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="zhTime">
                        <input type="text" class="form-control laydate-icon" v-model="zhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="zhEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zhShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="zh_room_area" ref="zh_room_area" readonly @click="zhRoomAreaFun()">
                    <span class="selection-clear" @click="clear_input('zhRoomAreaFun')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-2">班次:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="banci" data-placeholder="请选择班次"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">价格策略:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bill_price_rule" data-placeholder="请选择价格策略"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getZhList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getZhExportSet">导出</button>
                </div>
            </div>
            <div class="zh-table">
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="zh_list_table">
                    <el-table-column
                        v-for="(item, index) in zh_column_tit"
                        :fixed="item.fixed"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width">
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :total="zh_list_total"
                    @current-change="getZhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="zhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='zhExport_allcheck' @click='zhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in zhExport_checkData" :key="item.key">
                            <input type="checkbox" v-model='zhExport_checkModel' :value="item.key">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='zhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='zhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="ele-hide" ref="zh_area_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='zh_area_allcheck' v-on:click='zhAreaCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in zh_area_data" :key="item.id">
                            <input type="checkbox" v-model='zh_area_model' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                zhStartTime: "",
                zhEndTime: "",
                zh_room_area: '',
                zh_area_allcheck: false,
                zh_c_area_allcheck: false,
                zh_area_model: [],
                zh_area_data: [],
                zhExport_allcheck: false,
                c_zhExport_allcheck: false,
                zhExport_checkModel: [],
                zhExport_checkData: [],
                zhExport_type: 1,
                zhColumns: [],
                zh_list_total: 0,
                zh_list_table: [],
                zh_column_tit: [],
                zh_page: 1,
                book_export_log_list: [], // 预约导出记录
            }
        },
        watch: {
            zh_room_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.zh_room_area).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.zh_room_area).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            zh_area_model: {
                handler: function (val, oldVal) {
                    if(this.zh_area_model.length >= this.zh_area_data.length) {
                        this.zh_area_allcheck = true;
                        this.zh_c_area_allcheck = true;
                    } else {
                        this.zh_area_allcheck = false;
                        this.zh_c_area_allcheck = false;
                    }
                },
                deep: true
            },
            zhExport_checkModel: {
                handler: function (val, oldVal) {
                    let _this = this;
                    if(this.zhExport_checkModel.length >= this.zhExport_checkData.length) {
                        this.zhExport_allcheck = true;
                        this.c_zhExport_allcheck = true;
                    } else {
                        this.zhExport_allcheck = false;
                        this.c_zhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.zhStartTime = moment().format('YYYY-MM-DD 08:00');
            this.zhEndTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.zhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.zhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.zhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.zhStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.zhEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.zhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.zh_room_area = '';
                                    _this.zh_area_model = [];
                                    $(_this.$refs.zh_room_area).prop('disabled', true);
                                    $(_this.$refs.banci).prop("disabled", true);
                                    $(_this.$refs.bill_price_rule).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.zh_room_area).prop('disabled', false);
                                _this.zh_room_area = '';
                                _this.zh_area_model = [];
                                _this.getRoomAreaData(e.params.data.id);
                                $(_this.$refs.banci).prop("disabled", false);
                                _this.getBanci(e.params.data.id)
                                $(_this.$refs.bill_price_rule).prop("disabled", false);
                                _this.getBillPriceRule(e.params.data.id)
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.zhShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            $(_this.$refs.zh_room_area).prop('disabled', false);
                            _this.getRoomAreaData($(_this.$refs.zhShop).val());
                            // 班次
                            $(_this.$refs.banci).prop("disabled", false);
                            _this.getBanci($(_this.$refs.zhShop).val())
                            // 价格策略
                            $(_this.$refs.bill_price_rule).prop("disabled", false);
                            _this.getBillPriceRule($(_this.$refs.zhShop).val())
                            _this.getZhList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomAreaData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.zh_area_data = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取门店班次
            getBanci: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "field": "shift_setting" // 查询的门店参数名称
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfig",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v, text: v });
                            });
                            $(_this.$refs.banci).html('');
                            $(_this.$refs.banci).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getBillGoodsPriceRule",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.bill_price_rule).html('');
                            $(_this.$refs.bill_price_rule).select2({
                                data: arr,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 清空多选
            clear_input: function() {
                this.zh_room_area = "";
                this.zh_area_model = [];
            },
            // 包厢区域全选
            zhAreaCheckedAll: function() {
                let _this = this;
                _this.zh_area_allcheck = _this.zh_c_area_allcheck;
                if(!_this.zh_area_allcheck) { // 实现全选
                    _this.zh_area_model = [];
                    _this.zh_area_data.forEach(function(item) {
                        _this.zh_area_model.push(item.id);
                    });
                } else { // 实现反选
                    _this.zh_area_model = [];
                }
            },
            // 选择包厢区域
            zhRoomAreaFun: function() {
                let _this = this;

                let zh_c_area_model = _this.zh_area_model;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['支付类型', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.zh_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.zh_room_area != "") {
                            _this.zh_area_model = zh_c_area_model;
                            return;
                        }
                        _this.zh_room_area = [];
                    }
                }, function() {
                    let areaTxts = [];
                    _this.zh_area_data.forEach(function(item) {
                        _this.zh_area_model.forEach(function(item2) {
                            if(item.id == item2) {
                                areaTxts.push(item.name);
                            }
                        });
                    });
                    _this.zh_room_area = areaTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.zh_room_area != "") {
                        _this.zh_area_model = zh_c_area_model;
                        return;
                    }
                    _this.zh_area_model = [];
                });
            },
            // 获取账单汇总报表
            getZhList: function(page) {
                let _this = this,
                    room_area = [];
                if(_this.zh_area_model.length != '0' && !_this.zh_area_allcheck) {
                    room_area = _this.zh_area_model;
                }
                _this.loading = true;
                _this.zh_page = page;
                Vue.axios.post('FinanceReport/billCount', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zhStartTime,
                            "end_date": _this.zhEndTime,
                            "shop_id": $(_this.$refs.zhShop).val(),
                            "room_area": room_area,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == '1') {
                            _this.zh_list_total = Number(res.data.response.result.count);
                            _this.zh_column_tit = [];
                            _this.zhExport_checkData = [];
                            for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                if(key == 'business_date') {
                                    _this.zh_column_tit.push({ prop: key, label: value, width: '110' });
                                } else {
                                    _this.zh_column_tit.push({ prop: key, label: value, width: 'auto' });
                                }
                                _this.zhExport_checkData.push({ key: key, name: value });
                            }
                        }
                        _this.zh_list_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 获取导出设置
            getZhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/billCountExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.zhExport_checkModel = data.response.result.export_fields;
                                _this.zhExport_type = data.response.result.export_type;
                            } else {
                                _this.zhExport_checkModel = [];
                                _this.zhExport_checkData.forEach(function(item) {
                                    _this.zhExport_checkModel.push(item.key);
                                });
                                _this.zhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.zhExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            zhExportCheckedAll: function() {
                let _this = this;
                _this.zhExport_allcheck = _this.c_zhExport_allcheck;
                if(!_this.zhExport_allcheck) { // 实现全选
                    _this.zhExport_checkModel = [];
                    _this.zhExport_checkData.forEach(function(item) {
                        _this.zhExport_checkModel.push(item.key);
                    });
                } else { // 实现反选
                    _this.zhExport_checkModel = [];
                }
            },

            // 预约导出
            checkExport() {
                let _this = this,
                    room_area = [];
                if (_this.zh_area_model.length != '0' && !_this.zh_area_allcheck) {
                    room_area = _this.zh_area_model;
                }
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'billCount',
                        "param": {
                            "page": _this.zh_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zhStartTime,
                            "end_date": _this.zhEndTime,
                            "shop_id": $(_this.$refs.zhShop).val(),
                            "room_area": room_area,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportZhList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this,
                    shop_id = $(_this.$refs.zhShop).val(),
                    room_area = [];

                if (_this.zhExport_checkModel.length == '0') {
                    layer.msg('导出字段不能为空');
                    return false;
                }
                if (_this.zh_area_model.length != '0' && !_this.zh_area_allcheck) {
                    room_area = _this.zh_area_model;
                }
                let export_fields = JSON.stringify(_this.zhExport_checkModel);

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'billCount',
                        "param": {
                            "page": _this.zh_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.zhStartTime,
                            "end_date": _this.zhEndTime,
                            "shop_id": shop_id,
                            "room_area": room_area,
                            "shift_name": $.trim($(_this.$refs.banci).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            _this.book_export_log_list = res.data.response.result.log_list
                        } else {
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 导出账单汇总列表
            exportZhList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.zhShop).val(),
                    room_area = [];

                if(_this.zhExport_checkModel.length == '0') {
                    layer.msg('导出字段不能为空');
                    return false;
                }
                if(_this.zh_area_model.length != '0' && !_this.zh_area_allcheck) {
                    room_area = _this.zh_area_model;
                }
                let export_fields = JSON.stringify(_this.zhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/billCountExport?" +
                    "&start_date=" + _this.zhStartTime +
                    "&end_date=" + _this.zhEndTime +
                    "&shop_id=" + shop_id +
                    "&room_area=" + room_area +
                    "&shift_name=" + $.trim($(_this.$refs.banci).val()) +
                    "&bill_goods_price_rule_id=" + $.trim($(_this.$refs.bill_price_rule).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.zhExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .zh-list {
        height: 100%;
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>